<h1>{{'cart.ean-view' | i18next}}</h1>

<owl-carousel-o [options]="customOptions" class="auto">
  <ng-container *ngFor='let cartItem of cartItems'>
    <ng-template carouselSlide>
      <h1 class="margin-0 text-center">{{ cartItem.product.texts.title |i18next }}</h1>
      <div class="flex-container align-center-middle">
        <div class="relative shrink">
          <div class="count shrink">
            {{ cartItem.quantity }}x
          </div>
          <ngx-barcode6 [bc-background]="background" [bc-display-value]="true"
                        [bc-height]="180"
                        [bc-margin-bottom]="50"
                        [bc-margin-left]="50"
                        [bc-margin-right]="50"
                        [bc-margin-top]="50"
                        [bc-value]="cartItem.product.gtin"
                        [bc-width]="3"
                        class="shrink"
          >
          </ngx-barcode6>
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
<ng-content></ng-content>
